import {Col, Container, Row} from "react-bootstrap";
import headerImg from '../../assets/img/izzigo-thumb-530x357-589824499.png'

export const Banner = () => {
    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <h1 className="text-center">
                            Bienvenido al portal comercial izzi
                        </h1>
                        <p className="text-center">
                            Estamos encantados de tenerte aquí. Este espacio está diseñado
                            para facilitar tu acceso a la información más importante y
                            actualizada de nuestra empresa.
                        </p>
                        <p className={"text-center"}>
                            El contenido está al alcance de un clic, porque queremos asegurarnos de que tengas las
                            herramientas
                            necesarias para estar informado y conectado con lo que sucede en izzi.
                        </p>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <img src={headerImg} alt="Promotional"/>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}